export default __webpack_public_path__ + "static/media/CookiePolicyTR.3b8a8ec1.pdf";